import {ease} from './sequence';

/** One score drives the assembly, reading and the shared 3D actor. */
export const FREELANCE_SCORE={towers:5600,deck:7400,cables:9000,materials:10800,theses:12800,flight:18200,end:24600} as const;
export function sampleFreelance(ms:number,reduced=false){
 const t=reduced?1e6:ms,s=FREELANCE_SCORE;
 return {
  towers:ease((t-s.towers)/1800),deck:ease((t-s.deck)/1600),cables:ease((t-s.cables)/1800),materials:ease((t-s.materials)/2000),
  flight:ease((t-s.flight)/(s.end-s.flight)),
  theses:[0,1,2].map(i=>ease((t-s.theses-i*1800)/900)),
  ending:ease((t-17000)/1000),complete:t>=s.end,
 };
}
